module.exports = __webpack_public_path__ + "img/workshop@488w.ac8db138.webp";